import React, {  useState, useEffect } from 'react';
import './MiniPagination.scss'

const MiniPagination = ({actualNum,total,totalText, letfFunc, rightFunc, color}) => {


    return ( 
        <div className="MiniPagination">
            <img style={{marginRight: 8}} onClick={letfFunc} src={0 == actualNum ? `/img/Pagination/D-${color}-arrow-left.svg` : `/img/Pagination/A-${color}-arrow-left.svg`}/>
            <span className={`MiniPagination-text_${color}`}>{` ${actualNum+1} / ${totalText} `}</span>
            <img style={{marginLeft: 8}} onClick={rightFunc} src={total == actualNum ? `/img/Pagination/D-${color}-arrow-right.svg` : `/img/Pagination/A-${color}-arrow-right.svg`}/>
        </div>
     );
}
 
export default MiniPagination;